import * as api from './api'

// 统一导出
export default {
    api
}

